'use strict';

var Howler = void 0;

if (typeof window !== 'undefined') {
  Howler = require('howler');
}

module.exports = Howler;


//////////////////
// WEBPACK FOOTER
// ./~/react-howler/lib/howler.js
// module id = 398
// module chunks = 0